<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div class="border-0">
                <h5 class="text-center mt-3">Welcome Back {{ user.name || '' }}</h5>
                <h6 v-if="eventName" class="text-center mt-3">Event: {{ eventName || '' }}</h6>

                <!-- Business Card Form -->
                <form class="imageform d-grid gap-2" id="business-card-form" @submit.prevent="submitForm('business_card')" enctype="multipart/form-data">
                    <div class="mb-3">
                        <input type="hidden" name="scan_type" value="business_card" />
                        <input
                            class="form-control d-none"
                            type="file"
                            name="image"
                            id="scan_image"
                            ref="businessCardInput"
                            @change="handleFileSelect($event, 'business_card')"
                        >
                        <div v-if="errors.business_card" class="invalid-feedback d-block text-center">
                            <strong>{{ errors.business_card }}</strong>
                        </div>
                        <img
                            v-if="previews.business_card"
                            :src="previews.business_card"
                            class="img-thumbnail mt-3"
                            id="business-card-preview"
                        >
                    </div>

                    <template v-if="files.business_card">
                        <button v-if="processing" class="btn btn-theme disabled d-grid gap-2 d-flex align-items-center justify-content-center" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                            <span role="status">Processing...</span>
                        </button>
                        <button
                            v-else
                            type="submit"
                            class="btn btn-theme d-grid"
                        >Upload</button>
                    </template>
                </form>

                <!-- Referral Sheet Form -->
                <form class="imageform d-grid gap-2" id="referral-sheet-form" @submit.prevent="submitForm('referral_sheet')" enctype="multipart/form-data">
                    <div class="mb-3">
                        <input type="hidden" name="scan_type" value="referral_sheet" />
                        <input
                            class="form-control d-none"
                            type="file"
                            name="image"
                            id="scan_referral_sheet"
                            ref="referralSheetInput"
                            @change="handleFileSelect($event, 'referral_sheet')"
                        >
                        <div v-if="errors.referral_sheet" class="invalid-feedback d-block text-center">
                            <strong>{{ errors.referral_sheet }}</strong>
                        </div>
                        <img
                            v-if="previews.referral_sheet"
                            :src="previews.referral_sheet"
                            class="img-thumbnail mt-3"
                            id="referral-sheet-preview"
                        >
                    </div>
                    <template v-if="files.referral_sheet">
                        <button v-if="processing" class="btn btn-theme disabled d-grid gap-2 d-flex align-items-center justify-content-center" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                            <span role="status">Processing...</span>
                        </button>
                        <button
                            v-else
                            type="submit"
                            class="btn btn-theme d-grid"
                        >Upload</button>
                    </template>
                </form>

                <!-- Scan Buttons and Event Form -->
                <div class="d-flex justify-content-center align-items-center" style="height: 50vh">
                    <div class="d-grid gap-2 col-12 mx-auto">
                        <label
                            for="scan_image"
                            type="button"
                            class="btn btn-outline-theme"
                            id="scan_image_label"
                        >
                            Scan - Business Card
                        </label>
                        <label
                            for="scan_referral_sheet"
                            type="button"
                            class="btn btn-outline-theme"
                            id="scan_referral_sheet_label"
                        >
                            Scan - RTLFS
                        </label>

                        <!-- Event Name Form -->
                        <form @submit.prevent="saveEvent" class="d-grid gap-2 mt-3">
                            <input
                                type="text"
                                v-model="eventName"
                                id="event_name"
                                class="form-control text-center"
                                placeholder="Event Name"
                            />
                            <button v-if="processing === 'save_event'" class="btn btn-theme disabled gap-2 d-flex align-items-center justify-content-center" type="button" disabled>
                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <span role="status">Processing...</span>
                            </button>
                            <button
                                v-else
                                type="submit"
                                class="btn btn-theme"
                                :disabled="!eventName.trim()"
                            >
                                Save Event
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScanCard',
    props: {

    },
    data() {
        return {
            processing: false,
            activeForm: null,
            eventName: localStorage.getItem('event_name') || '',
            files: {
                business_card: null,
                referral_sheet: null
            },
            previews: {
                business_card: null,
                referral_sheet: null
            },
            errors: {
                business_card: null,
                referral_sheet: null
            }
        }
    },
    mounted() {
        this.eventName = localStorage.getItem('event_name') || '';
    },
    computed: {
        user() {
            return this.$store.getters.getUser || {};
        }
    },
    watch: {

    },
    methods: {
        handleFileSelect(event, type) {
            console.log(type, event);
            const file = event.target.files[0];
            if (!file) return;

            // Validate file type
            if (!file.type.startsWith('image/')) {
                this.errors[type] = 'Please select a valid image file.';
                return;
            }

            // Clear previous errors
            this.errors[type] = null;

            // Store file
            this.files[type] = file;

            // Create preview
            const reader = new FileReader();
            reader.onload = (e) => {
                this.previews[type] = e.target.result;

                // Auto-submit after preview is loaded (matches Laravel Blade timing)
                this.$nextTick(() => {
                    this.submitForm(type);
                });
            };
            reader.readAsDataURL(file);

            //this.submitForm(type);
        },

        async submitForm(scanType) {
            if (!this.files[scanType]) {
                this.errors[scanType] = 'Please select an image to upload.';
                return;
            }

            this.processing = true;
            this.activeForm = scanType;
            this.errors[scanType] = null;

            try {
                const formData = new FormData();
                formData.append('image', this.files[scanType]);
                formData.append('scan_type', scanType);
                formData.append('event_name', this.eventName);

                const response = await axios.post('/api/cards/uplaod', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if(response.data.status == 'success') {
                    window.location.href = response.data.redirect;
                }
                else {
                    this.errors[scanType] = response.data.message;
                }


                // Reset form
                this.files[scanType] = null;
                this.previews[scanType] = null;

                // Reset file input
                if (scanType === 'business_card') {
                    this.$refs.businessCardInput.value = '';
                } else {
                    this.$refs.referralSheetInput.value = '';
                }
            } catch (error) {
                console.error('Upload error:', error);

                // Handle validation errors
                if (error.response && error.response.data) {
                    if (error.response.data.errors && error.response.data.errors.image) {
                        this.errors[scanType] = error.response.data.errors.image[0];
                    } else {
                        this.errors[scanType] = error.response.data.message || 'An error occurred while uploading.';
                    }
                } else {
                    this.errors[scanType] = 'Network error. Please try again.';
                }
            } finally {
                this.processing = false;
                this.activeForm = null;
            }
        },

        async saveEvent() {
            if (!this.eventName.trim()) return;
            this.processing = 'save_event';
            // Store the event name in the local storage
            localStorage.setItem('event_name', this.eventName);
            this.processing = false;
        }
    }
}
</script>
